/** Persisted navbar cart badge (sum of item quantities). */
export const CART_BADGE_COUNT_KEY = 'cart_badge_total_quantity';
export const CART_BADGE_UPDATED_AT_KEY = 'cart_badge_updated_at';

export function readPersistedCartBadgeCount(): number {
  const raw = localStorage.getItem(CART_BADGE_COUNT_KEY);
  if (raw === null) return 0;
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
}

export function writePersistedCartBadgeCount(count: number): void {
  const safe = Number.isFinite(count) && count >= 0 ? Math.floor(count) : 0;
  localStorage.setItem(CART_BADGE_COUNT_KEY, String(safe));
  localStorage.setItem(CART_BADGE_UPDATED_AT_KEY, new Date().toISOString());
}

export function clearPersistedCartBadgeCount(): void {
  localStorage.removeItem(CART_BADGE_COUNT_KEY);
  localStorage.removeItem(CART_BADGE_UPDATED_AT_KEY);
}

export function countCartTotalQuantity(
  items: Array<{ quantity?: number | string | null }> | undefined | null,
): number {
  return (items ?? []).reduce(
    (sum, item) => sum + Number(item.quantity ?? 0),
    0,
  );
}

export function shouldFetchCartSummary(state: {
  auth: { user?: { id?: string } | null; bootstrapComplete?: boolean };
  cart: { sessionId?: string };
}): boolean {
  const userId = state.auth?.user?.id;
  if (userId) {
    return state.auth.bootstrapComplete === true;
  }

  const sessionId =
    state.cart.sessionId?.trim() ||
    localStorage.getItem('cart_session_id')?.trim() ||
    '';
  if (!sessionId) return false;

  return localStorage.getItem('cart_guest_activity') === '1';
}
